export const containerStyle = {
  minHeight: '100vh',
  background: '#f6f8fa',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '20px',
};

export const cardStyle = {
  minWidth: 400,
  maxWidth: 520,
  width: '100%',
  margin: '0 auto',
  padding: '3rem 3rem',
  borderRadius: 12,
  background: '#fff',
  boxShadow: '0 4px 24px rgba(0,0,0,0.10), 0 1.5px 4px rgba(0,0,0,0.08)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
};

export const headingStyle = {
  fontSize: '1.4rem',
  fontWeight: 600,
  marginTop: '2rem',
  marginBottom: '0.75rem',
  minHeight: '1.8rem', // Reserve space to prevent shifts
  color: '#222',
  letterSpacing: 0.2,
  textAlign: 'center',
  lineHeight: '1.3',
};

export const textStyle = {
  color: '#666',
  fontSize: '1rem',
  textAlign: 'center',
  marginBottom: '1.5rem',
  minHeight: '3rem', // Reserve space for 2 lines of text
  lineHeight: '1.5',
  fontWeight: 400,
};

export const spinnerContainerStyle = {
  marginTop: '0.5rem',
  marginBottom: '1rem',
  height: '48px', // Fixed height prevents layout shifts
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const buttonStyle = {
  background: '#1976d2',
  color: 'white',
  border: 'none',
  padding: '10px 20px',
  borderRadius: '4px',
  cursor: 'pointer',
  fontSize: '16px',
  fontWeight: 500,
};

export const errorContainerStyle = {
  minHeight: '60px', // Reserve space for error messages
  marginBottom: '1.5rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
};

export const spinnerSvg = (
  <svg
    width='36'
    height='36'
    viewBox='0 0 38 38'
    xmlns='http://www.w3.org/2000/svg'
    stroke='#1976d2'
  >
    <g fill='none' fillRule='evenodd'>
      <g transform='translate(1 1)' strokeWidth='3'>
        <circle strokeOpacity='.2' cx='18' cy='18' r='18' />
        <path d='M36 18c0-9.94-8.06-18-18-18'>
          <animateTransform
            attributeName='transform'
            type='rotate'
            from='0 18 18'
            to='360 18 18'
            dur='1s'
            repeatCount='indefinite'
          />
        </path>
      </g>
    </g>
  </svg>
);
